// 汎用的なfetch用エラーハンドラー
// todo: エラーログの送信先の設定
export function handleFetchError(error: unknown, context?: string): never {
  let message = "";
  if (error instanceof Error) {
    message = error.message;
  } else if (typeof error === "string") {
    message = error;
  } else {
    message = JSON.stringify(error);
  }
  throw new Error(`${context ? `${context}: ` : ""}${message}`);
}

/**
 * 非同期関数を汎用的にtry-catchでラップし、エラーハンドラーに委譲する高階関数
 */
export const withErrorHandler = async <T>(
  fn: () => Promise<T>,
  context?: string,
): Promise<T> => {
  return fn().catch((error: unknown) => handleFetchError(error, context));
};
